<template>
  <v-dialog :value="abierto" max-width="720px" @input="alCambiarDialogo">
    <v-card class="lanzamiento">
      <div class="lanzamiento-cuerpo">
        <!-- Ilustración: la imagen de la campaña o un dibujo neutro si no cargaron una -->
        <v-img
          v-if="campania.url_imagen"
          :src="campania.url_imagen"
          :alt="campania.titulo"
          class="lanzamiento-imagen"
          width="300"
          cover
        />
        <div v-else class="lanzamiento-ilustracion grey lighten-4">
          <svg width="120" height="120" viewBox="0 0 24 24" aria-hidden="true">
            <path
              fill="currentColor"
              d="M12,18H6V14H12M21,14V12L20,7H4L3,12V14H4V20H14V14H18V20H20V14M20,4H4V6H20V4Z"
            ></path>
          </svg>
        </div>

        <div class="lanzamiento-contenido">
          <div class="d-flex align-center justify-space-between">
            <v-chip x-small label color="primary" class="white--text lanzamiento-chip">Novedad</v-chip>
            <v-btn icon small data-test="boton-cerrar" aria-label="Cerrar" @click="cerrar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <h2 class="lanzamiento-titulo">{{ campania.titulo }}</h2>
          <p v-if="campania.texto" class="lanzamiento-texto">{{ campania.texto }}</p>

          <div class="d-flex align-center flex-wrap lanzamiento-acciones">
            <v-btn
              v-if="campania.boton_texto"
              color="primary"
              depressed
              class="white--text"
              data-test="boton-principal"
              @click="irAlEnlace"
            >
              {{ campania.boton_texto }}
              <v-icon right small>mdi-arrow-right</v-icon>
            </v-btn>
            <v-btn text data-test="boton-ahora-no" @click="cerrar">Ahora no</v-btn>
          </div>

          <v-checkbox
            v-model="noVolverAMostrar"
            dense
            hide-details
            label="No volver a mostrar"
            class="lanzamiento-casilla"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { abrirEnlaceCampania } from "@/utils/publicidadEnlace";

/**
 * Ventana emergente de una campaña de lanzamiento. Solo la monta PublicidadOverlay
 * en el Inicio, una vez por carga de la app. Cerrar por cualquier vía cuenta como
 * "cerrada"; con la casilla marcada, como "no_mostrar".
 */
export default {
  name: "LanzamientoDialog",
  props: {
    campania: { type: Object, required: true },
  },
  data() {
    return {
      abierto: true,
      noVolverAMostrar: false,
    };
  },
  mounted() {
    this.$store.dispatch("publicidad/verVista", this.campania.id);
  },
  methods: {
    alCambiarDialogo(valor) {
      if (!valor) this.cerrar();
    },
    cerrar() {
      if (!this.abierto) return;
      this.abierto = false;
      const accion = this.noVolverAMostrar ? "publicidad/noMostrar" : "publicidad/cerrar";
      this.$store.dispatch(accion, this.campania.id);
      this.$emit("cerrado");
    },
    irAlEnlace() {
      this.$store.dispatch("publicidad/clic", this.campania.id);
      abrirEnlaceCampania(this.campania.boton_url);
      this.cerrar();
    },
  },
};
</script>

<style scoped>
.lanzamiento-cuerpo {
  display: flex;
  min-height: 360px;
}
.lanzamiento-imagen,
.lanzamiento-ilustracion {
  flex: 0 0 300px;
}
.lanzamiento-ilustracion {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.26);
}
.lanzamiento-contenido {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 24px 20px;
}
.lanzamiento-chip {
  letter-spacing: 0.06em;
  text-transform: uppercase;
}
.lanzamiento-titulo {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
  margin: 0;
}
.lanzamiento-texto {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
  margin: 0;
}
.lanzamiento-acciones {
  gap: 8px;
  margin-top: auto;
}
.lanzamiento-casilla {
  margin-top: 0;
}
@media (max-width: 700px) {
  .lanzamiento-cuerpo {
    flex-direction: column;
  }
  .lanzamiento-imagen,
  .lanzamiento-ilustracion {
    flex-basis: 160px;
    min-height: 160px;
  }
}
</style>
